import styled from 'styled-components'

const Wrapper = styled.div`
  max-width: 980px;
  padding: 0 30px;
  margin: 0 auto;
`

export default Wrapper
